import { diffLines, type DiffLine, type DiffLineType } from "@/lib/utils/text-diff"

const DIFF_LINE_STYLES: Record<DiffLineType, string> = {
  add: "bg-green-50 text-green-900",
  remove: "bg-red-50 text-red-900",
  equal: "",
}

const DIFF_LINE_MARKERS: Record<DiffLineType, string> = {
  add: "+ ",
  remove: "− ",
  equal: "  ",
}

/** A line diff of two versions of a text; `labels` say what each side is. */
export function PromptDiff({
  prev,
  next,
  labels,
}: {
  prev: string
  next: string
  labels: { prev: string; next: string }
}) {
  return (
    <div className="font-mono text-xs">
      <p className="mb-2 text-muted-foreground">
        <span className="text-red-600">− {labels.prev}</span>{" "}
        <span className="text-green-700">+ {labels.next}</span>
      </p>
      <DiffLines lines={diffLines(prev, next)} />
    </div>
  )
}

/** Lines marked as they differ — a whole diff, or one change's lines on their own. */
export function DiffLines({ lines }: { lines: DiffLine[] }) {
  return lines.map((line, index) => (
    <div
      key={index}
      data-diff={line.type}
      className={`whitespace-pre-wrap break-words ${DIFF_LINE_STYLES[line.type]}`}
    >
      {`${DIFF_LINE_MARKERS[line.type]}${line.text}`}
    </div>
  ))
}
